import Vue from "vue";
import _ from "lodash";

export default Vue.mixin({
  methods: {
    async validateForm(scope, callback) {
      if (this.$validator && (await this.$validator.validateAll(scope))) {
        callback();
      }
      return false;
    },
    async pushDeviceInfo(notificationsToken = null, tokenType = null) {
      this.$http.post(
        "/api/v1/campaigns/" + this.$store.state.campaign.id + "/users/devices",
        {
          notifications_token: notificationsToken,
          notifications_type: tokenType
        }
      );
    },
    manageError(error, payload = null) {
      if (!payload) {
        payload = {
          type: "waiting",
          title: this.$i18n.t("Error")
        };
      }
      let errorStatus = _.get(error, "response.status");
      if (errorStatus === 409) {
        this.$store.commit("pushMessage", {
          type: "waiting",
          title: this.$i18n.t("L'utente è già registrato")
        });
      } else {
        this.$store.commit("pushMessage", payload);
      }
    }
  }
});
